<div class="error-content">
    <div class="error-text">Oops!</div>
    <p>It appears this service is not currently available.<br>We're really sorry, please try again later!</p>
</div>